





import { Vue, Component } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  name: string = 'App'
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue